module.exports = __webpack_public_path__ + "media/images/instance-b8ee0cdbfa262dd848faa1366ecb491b.svg";